import { createSlice } from "@reduxjs/toolkit"
import { IUser } from "store/apis/userAPI/user.types"
import { resetProfession } from "store/apis/professionsAPI"
import { unpackPreform } from "../apis/preformAPI"
import { gatDailyRewards } from "../apis/dailyRewardsAPI"
import { getLocationUserProgress } from "../apis/locationAPI/location.api.ts"
import {
  getUserData,
  refreshMyPositionInLeaders,
  setDogName
} from "../apis/userAPI"

export const initialState: IUser & { isUserProgressLoading: boolean } = {
  dailyRewards: [],
  _id: "",
  telegram: "",
  name: "",
  username: "unnamed_user",
  avatar: "",
  referralCode: "",
  isPremium: false,
  location: 1,
  dogname: "",
  wallets: { telegram: "" },
  isGameFinished: false,
  rank: 1,
  currentDiggingSpeed: 0,
  currentLuck: 0,
  currentStamina: 0,
  currentEndurance: 0,
  currentIntuition: 0,
  currentCraftRunePriceBonus: 0,
  currentCraftToolPriceBonus: 0,
  currentCraftRuneSuccessBonus: 0,
  positionInLeaders: 0,
  isUserProgressLoading: false
}

export const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    refreshRank: (state) => {
      state.rank = state.rank > 0 ? state.rank : state.rank * -1
    },

    refreshCurrentUserStats: (state, { payload }) => {
      state.currentDiggingSpeed =
        payload?.currentDiggingSpeed ?? state.currentDiggingSpeed
      state.currentLuck = payload?.currentLuck ?? state.currentLuck
      state.currentStamina = payload?.currentStamina ?? state.currentStamina
      state.currentEndurance =
        payload?.currentEndurance ?? state.currentEndurance
      state.currentIntuition =
        payload?.currentIntuition ?? state.currentIntuition
      state.currentCraftRunePriceBonus =
        payload?.currentCraftRunePriceBonus ?? state.currentCraftRunePriceBonus
      state.currentCraftToolPriceBonus =
        payload?.currentCraftToolPriceBonus ?? state.currentCraftToolPriceBonus
      state.currentCraftRuneSuccessBonus =
        payload?.currentCraftRuneSuccessBonus ??
        state.currentCraftRuneSuccessBonus
    },

    updatePositionInLeaders: (state, { payload }) => {
      state.positionInLeaders = payload
    },

    updateEmail: (state, { payload }) => {
      state.email = payload
    },

    updateUserVipPass: (state, { payload }) => {
      state.hasVipPass = payload
    }
  },

  extraReducers: (builder) => {
    builder.addMatcher(resetProfession.matchFulfilled, (state, { payload }) => {
      state.currentDiggingSpeed = payload.currentDiggingSpeed
    })

    builder.addMatcher(gatDailyRewards.matchFulfilled, (state, { payload }) => {
      state.dailyRewards = payload
    })

    builder
      .addMatcher(
        getLocationUserProgress.matchFulfilled,
        (state, { payload }) => {
          state.location = payload.locationIndex
          state.isGameFinished = payload.isGameFinished
          state.isUserProgressLoading = false
        }
      )
      .addMatcher(getLocationUserProgress.matchRejected, (state) => {
        state.isUserProgressLoading = false
      })
      .addMatcher(getLocationUserProgress.matchPending, (state) => {
        state.isUserProgressLoading = true
      })

      .addMatcher(getUserData.matchFulfilled, (state, { payload }) => {
        localStorage.setItem("userId", payload._id)

        state.username = payload.username || "***"

        Object.assign(state, payload)
      })
      .addMatcher(setDogName.matchFulfilled, (state, { payload }) => {
        state.dogname = payload
      })
      .addMatcher(unpackPreform.matchFulfilled, (_, { payload }) => {
        console.log("You won a new tool: ", payload.rewardItem)
      })

    builder.addMatcher(
      refreshMyPositionInLeaders.matchFulfilled,
      (state, { payload }) => {
        state.positionInLeaders = payload.position
      }
    )
  }
})

export const {
  updateUserVipPass,
  updateEmail,
  updatePositionInLeaders,
  refreshRank,
  refreshCurrentUserStats
} = UserSlice.actions
